/** Pages for people outside the CRM (a customer opening a proposal link): no sign-in check, no offline app */
export const isPublicPage = () => typeof window !== "undefined" && /^\/p\//.test(window.location.pathname);
